import { render } from "./FutureTripsPage.vue?vue&type=template&id=1c8f221d&scoped=true&ts=true"
import script from "./FutureTripsPage.vue?vue&type=script&lang=ts"
export * from "./FutureTripsPage.vue?vue&type=script&lang=ts"

import "./FutureTripsPage.vue?vue&type=style&index=0&id=1c8f221d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c8f221d"]])

export default __exports__